// export DsfDateIntervalPicker from './dateIntervalPicker';
// export DsfDatePicker from './datePicker';
// export DsfTimeIntervalPicker from './timeIntervalPicker';
// export DsfTimePicker from './timePicker';
// export PeriodPicker from './periodPicker';
// export DsfPeriodIntervalPicker from './periodIntervalPicker';

export const DsfPeriodPicker = dsf.defineLazyComponent("DsfPeriodPicker", () => require("./periodPicker.vue"));
export const DsfPeriodIntervalPicker = dsf.defineLazyComponent("DsfPeriodIntervalPicker", () => require("./periodIntervalPicker.vue"));
export const DsfDateIntervalPicker = dsf.defineLazyComponent("DsfDateIntervalPicker", () => require("./dateIntervalPicker.vue"));
export const DsfDatePicker = dsf.defineLazyComponent("DsfDatePicker", () => require("./datePicker.vue"));
export const DsfTimePicker = dsf.defineLazyComponent("DsfTimePicker", () => require("./timePicker.vue"));
export const DsfTimeIntervalPicker = dsf.defineLazyComponent("DsfTimeIntervalPicker", () => require("./timeIntervalPicker.vue"));
